import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Text } from '@beef/ui-kit';
import { I18n } from 'components';
import { ServiceLimit } from 'components/Cards/ServiceLimit';
import { useIsMobileWidth } from 'utils/hooks/useIsMobile';

// Constants
import { INVITATION_STATUS } from '../../../../constants';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const CtnStatus = ({ data }) => {
  const { accumulators, status, isProcessing } = data;
  const isMobileSize = useIsMobileWidth();

  if (status === INVITATION_STATUS.sent) {
    return (
      <Text size="size5-r-s" color="grey50">
        <I18n path="family.familyInvitationSent" />
      </Text>
    );
  }

  if (accumulators?.length) {
    if (isMobileSize) {
      return (
        <Text size="size5-r-s" color="grey50">
          <I18n path="family.numberIsConnectedText" />
        </Text>
      );
    }

    return (
      <div className={cn('limits')}>
        {accumulators.map((accumulator, index) => (
          <div className={cn('limits__item', {
            'limits__item--bordered': !!index,
            'limits__item--zero-left-padding': !index,
          })}
          >
            <ServiceLimit
              key={index}
              balance={accumulator.balance}
              limit={accumulator.limit}
              unit={accumulator.unit}
              isProcessing={isProcessing}
              unlimited={accumulator.unlimited}
              limitFromParent={accumulator.limitFromParent}
              parentLimit={accumulator.parentLimit}
              size="5-r-s"
            />
          </div>
        ))}
      </div>
    );
  }

  return (
    <Text size="size5-r-s" color="grey50">
      <I18n path="family.noLimitSetText" />
    </Text>
  );
};

CtnStatus.propTypes = {
  accumulators: PropTypes.arrayOf({
    name: PropTypes.string,
    image: PropTypes.string,
    limitFromParent: PropTypes.bool,
    roundedBalance: PropTypes.number,
    balance: PropTypes.number,
    parentLimit: PropTypes.number,
    limit: PropTypes.number,
    unit: PropTypes.string,
    step: PropTypes.number,
  }),
  status: PropTypes.string,
  isProcessing: PropTypes.bool,
};

export { CtnStatus };
